/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getProfiles.defs.js'
export * as $defs from './getProfiles.defs.js'
